module.exports = __webpack_public_path__ + "img/trip_05.fd359181.jpg";